import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgButton, IgDialog, IgTypography } from "@intelligems/ig-theme";
import CachedIcon from "@mui/icons-material/Cached";
import { Grid } from "@mui/material";

import { getDialog, IGlobalState, setDialog } from "../../store/slices/global";
import { IAppState } from "../../store/types/store";

export const UpdateDetectedDialog = () => {
  const dialog = useSelector(
    getDialog("updatedDetected")
  ) as IGlobalState["dialogs"]["updatedDetected"];

  const shouldIgnore = useSelector(
    (state: IAppState) => state.global.ignoreUpdateDetected
  );
  const dispatch = useDispatch();

  if (shouldIgnore) {
    return null;
  }

  return (
    <IgDialog
      handleClose={(event: any, reason: any) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          dispatch(setDialog({ dialog: "setDomain", open: false }));
        }
      }}
      rawContent={
        <Grid container item direction={"column"} rowSpacing={2}>
          <Grid item>
            <IgTypography>
              Updates have been made. Refresh <br /> the page to view the latest
              data.
            </IgTypography>
          </Grid>
          <Grid item>
            <IgButton
              startIcon={<CachedIcon />}
              onClick={() => window.location.reload()}
              variant={"contained"}
            >
              Refresh Now
            </IgButton>
          </Grid>
        </Grid>
      }
      title={"Updates Detected"}
      showDialog={dialog.isOpen}
      hideActions={true}
      shouldNotClose={true}
      dialogHeight={"210px"}
    />
  );
};
